import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader } from "@/components/common";
import { useApi, errMsg } from "@/lib/api";
import { dateOnly } from "@/lib/format";

const ROLE_LABEL = { admin: "Administrador", member: "Sin acceso" };

export default function UsersPage() {
  const api = useApi();
  const [data, setData] = useState({ roles: [], users: [] });
  const load = useCallback(() => api.get("/users").then((r) => setData(r.data)), [api]);
  useEffect(() => { load(); }, [load]);
  const change = async (uid, role) => {
    try { await api.patch(`/users/${uid}/role`, { role }); toast.success("Rol actualizado"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <PageHeader title="Administradores" subtitle="Personas que se registraron en el back-office. Solo los administradores pueden operar." />
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white">
        <table className="w-full min-w-[600px] text-sm" data-testid="users-table">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500"><tr><th className="px-4 py-3">Usuario</th><th className="px-4 py-3">Registro</th><th className="px-4 py-3">Rol</th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {data.users.map((u) => (
              <tr key={u.user_id} data-testid={`user-row-${u.user_id}`}>
                <td className="px-4 py-3.5"><p className="font-medium text-slate-900">{u.name || u.email}</p>{u.name && <p className="text-xs text-slate-500">{u.email}</p>}</td>
                <td className="px-4 py-3.5 text-slate-500">{dateOnly(u.created_at)}</td>
                <td className="px-4 py-3.5">
                  <Select value={u.role} onValueChange={(v) => change(u.user_id, v)}>
                    <SelectTrigger className="w-44" data-testid={`user-role-${u.user_id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{data.roles.map((r) => <SelectItem key={r} value={r}>{ROLE_LABEL[r] || r}</SelectItem>)}</SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
